export enum ContainerToken {
  mc = '44.8rem',
  sm = '64rem',
  md = '76.8rem',
  lg = '102.4em',
  xl = '128rem',
}

export default ContainerToken

export type TContainer = 'mc' | 'sm' | 'md' | 'lg' | 'xl'
